export function createReducerUsingActionHandlers(initialState, actionCreators) {
    return function reducerUsingActionHandlers(state = initialState, action) {
        const { type, ...extraProps } = action;
        const handler = actionCreators[type];
        return handler ? handler(state, extraProps) : state;
    };
}
//# sourceMappingURL=createReducerUsingActionHandlers.js.map